import React from "react";
import { mmss } from "./useVisitPhase";

/*
 * Date of Service: the tab's FIRST row, full width, pinned above the CareIQ
 * scroller at >= 1024 px. One grey status segment, no chips:
 *   before      "Established visit 10:30 AM"
 *   recording   "● Recording · 04:12" (Paused · 04:12)
 *   processing  "Note processing…"
 *   noteReady   "Note ready"
 * No visit today (owner 10-09: the chart is not on a live visit today): the
 * value reads "No visit today", with no status and no provider -- never the
 * date of a past, future, cancelled or no-show appointment.
 * A visit that did not happen, picked on purpose (a timeline pick), carries
 * its status after the date ("Cancelled", "No show", "Rescheduled").
 */
export default function DosRow({ dateText, provider, phase, visitText, elapsed, paused, noVisit = false, statusWord = "" }) {
  let seg;
  if (noVisit && phase !== "recording" && phase !== "processing") {
    // (a recording with no visit at all still says so; a note of another day is not this screen's)
    seg = null;
  } else if (phase === "recording") {
    seg = (
      <>
        {!paused && <span className="n3-rdot" aria-hidden="true" />}
        <span>{paused ? "Paused" : "Recording"} · <span className="n3-tnum">{mmss(elapsed)}</span></span>
      </>
    );
  } else if (phase === "processing") {
    seg = <span>Note processing…</span>;
  } else if (phase === "noteReady") {
    seg = <span>Note ready</span>;
  } else {
    seg = visitText ? <span>{visitText}</span> : null;
  }
  return (
    <div className="n3-dos" data-testid="n3-dos">
      {/* .n3-dos is a size container (n3dos, CareIQTabN3.css): the row inside lays out by the card's
          own width (one line, or two below 560 px), never the screen's */}
      <div className="n3-dos-in">
        <div className="n3-dos-a">
          <span className="n3-dos-k">Date of Service</span>
          <span className={`n3-dos-v${noVisit ? " n3-dos-none" : ""}`} data-testid="n3-dos-date">{noVisit ? "No visit today" : dateText}</span>
          {!noVisit && statusWord ? <span className="n3-dos-st" data-testid="n3-dos-visit-status">{statusWord}</span> : null}
          {seg && (
            <span className="n3-dos-vs" data-testid="n3-dos-status">
              <span className="n3-sep">·</span>
              {seg}
            </span>
          )}
        </div>
        {provider && !noVisit ? <span className="n3-dos-p">{provider}</span> : null}
      </div>
    </div>
  );
}
